module.exports = __webpack_public_path__ + "static/game-6-8ecd7700b365b0bc9cfb3a2a5f782782.png";